import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCookies } from '../../hooks/useCookies';

const ProtectedRoute = ({ children }) => {
  const { getCookie } = useCookies();
  const userId = getCookie('userId');
  const usertoken = getCookie('token');

  if (!userId && !usertoken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
